import { Stack } from '@mui/material';

import { Card, CardContent } from '../../surface/card/card.component';
import { CircularProgress } from '../circular-progress';

export const LoadingCard = () => {
  return (
    <Card>
      <CardContent>
        <Stack alignItems='center' padding={8}>
          <CircularProgress />
        </Stack>
      </CardContent>
    </Card>
  );
};
